import React, { FC, memo } from 'react';
import { BullSelector } from '../components';

/**
 * Fleckvieh bull selection screen.
 *
 * @returns The Fleckvieh bull selector screen.
 */
const BullSelectorCBase: FC = _ => <BullSelector title="Bullselector - C" associationType="FLECKVIEH" data-sentry-element="BullSelector" data-sentry-component="BullSelectorCBase" data-sentry-source-file="bull-selector-c.tsx" />;

/**
 * Memoized Fleckvieh bull selection screen.
 *
 * @returns The Fleckvieh bull selector screen.
 */
export const BullSelectorC = memo(BullSelectorCBase);